const youtubeModal = () => {
    const youtubeCardList = document.querySelectorAll('[data-block="youtube"]');

    try {
        youtubeCardList.forEach(item => {
            item.addEventListener('click', (e)=>{
                let target = e.target;

            

                if(target.classList.contains('youtube-link') || target.closest('.youtube-link')) {
                    e.preventDefault();

                    // ширина скролла
                    let divWidth = document.createElement('div'),
                    scrollWidth;

                    divWidth.style.overflowY = 'scroll';
                    divWidth.style.width = '50px';
                    divWidth.style.height = '50px';

                    document.body.appendChild(divWidth);
                    scrollWidth = divWidth.offsetWidth - divWidth.clientWidth;

                    document.body.removeChild(divWidth);
                    document.body.style.marginRight = scrollWidth + 'px';
                    document.body.style.overflow = 'hidden';
                    //END ширина скролла

                    let link;
                    let videoTitle = target.closest('.info-card');
                    if(target.classList.contains('youtube-link')) {
                        link = target;
                    } else if(target.closest('.youtube-link')) {
                        link = target.closest('.youtube-link');
                    }

                    let divModalWrap    = document.createElement('div'),
                        divModal        = document.createElement('div');

                    divModalWrap.classList.add('modal-wrap');
                    divModal.classList.add('modal');
                    divModal.classList.add('modal_900');
                    divModal.classList.add('slide-up-long');
                    
                    document.body.append(divModalWrap);
                    divModalWrap.append(divModal);

                    divModal.innerHTML = `
                        <div class="modal-hdr">
                            <span class="modal-title">${videoTitle.textContent}</span>
                            <div class="close-modal"></div>
                        </div>
                        <div class="modal-content">
                            <iframe width="100%" height="450" src="${link.href}" frameborder="0" allowfullscreen>
                            </iframe>
                        </div>
                    
                    `;
                    addEventListener('keydown', closeEsc);
                    divModalWrap.addEventListener('click', (event) => {
                        let target = event.target;

                        if(target.classList.contains('close-modal') || target.classList.contains('modal-wrap')){
                            divModalWrap.remove();
                            document.body.style.overflow = 'auto';
                            document.body.style.marginRight = '0px';
                            removeEventListener('keydown', closeEsc);
                        }
                    })
                }
            });
        });
    } catch(e){}
    function closeEsc(e) {
		if(e.keyCode === 27) {
            let modalBlock = document.querySelector('.modal-wrap');
            console.log(modalBlock)
            modalBlock.remove();
            
			removeEventListener('keydown', closeEsc);
			document.body.style.overflow = 'auto';
			document.body.style.marginRight = '0px';
		}
	}
};

export default youtubeModal;